import React from 'react';
import { Box, Typography, Stack, Chip } from '@mui/material';
import { DocumentView } from '../../../../../../services/RefundService/types/documentTypes';
import { getFileIcon, getFileTypeLabel } from '../utils';

interface DocumentInfoSectionProps {
  document: DocumentView;
}

export const DocumentInfoSection: React.FC<DocumentInfoSectionProps> = ({ document }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      p: 2,
      backgroundColor: '#f8fafc',
      borderRadius: 2,
      border: '1px solid #e2e8f0',
    }}
  >
    <Box
      sx={{
        p: 2,
        backgroundColor: '#fff',
        borderRadius: 1.5,
        border: '1px solid #e2e8f0',
      }}
    >
      {getFileIcon(document.extension)}
    </Box>
    <Box flex={1}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, wordBreak: 'break-word' }}>
        {document.fileName}
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        <Chip
          label={getFileTypeLabel(document.extension)}
          size="small"
          sx={{
            backgroundColor: '#dbeafe',
            color: '#1e40af',
          }}
        />
        <Chip label={document.extension.toUpperCase().slice(1)} size="small" variant="outlined" />
      </Stack>
    </Box>
  </Box>
);

export default DocumentInfoSection;
